import {useState} from 'react';
import {BigFetchWithCleanPosition, FetchPositionClean} from '../../../envisia/workflow/fetch/box/fetch-box.model';
import {EvButton} from '../../form/EvButton';
import {MergedFrame} from '../../../envisia/workflow/models/frame.models';
import {EvReactModal} from '../../modal/EvReactModal';
import {useFetchPriceConfirmMutation} from './use-fetch-price-confirm-mutation';
import {useFetchQuery} from './use-fetch-query';

interface Props {
  position: FetchPositionClean;
  fetch: BigFetchWithCleanPosition;
  frame: MergedFrame;
  reload: () => void;
}

export function PriceValidation(props: Props) {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const {fetchWrapper, fetchWrapperIsPending} = useFetchQuery({
    workflowId: props.frame.workflow_id,
    fetchId: props.fetch.id,
    enabled: !props.fetch.price_validated,
  });
  const {mutateFetchPriceConfirmIsPending, mutateFetchPriceConfirm} = useFetchPriceConfirmMutation({
    workflowId: props.frame.workflow_id,
    fetchId: props.fetch.id,
    successCallback: () => {
      props.reload();
      setModalOpen(false);
    },
  });

  if (fetchWrapperIsPending || !fetchWrapper?.requiresValidation) {
    return null;
  }

  return <>
    <EvButton variant="link"
              size="no-padding"
              type="button"
              title="Preis freigeben"
              onClick={() => setModalOpen(true)}>
      <i className="fa fa-times text-storz-red"/>
    </EvButton>
    <EvReactModal contentLabel="Preisfreigabe"
                  showModal={modalOpen}
                  modalClosed={() => setModalOpen(false)}>
      <div className="inline-block p-2 pl-0">
        <h4>Preis auf Abruf {props.fetch.ordering} (#{props.fetch.id}) muss freigegeben werden</h4>
        <ul className="pl-4 pb-2">
          {fetchWrapper.zeroPrice &&
            <li>Preis in Abruf ist 0,00€.</li>
          }
          {fetchWrapper.expiredPrice &&
            <li>Abruf Preis Gültigkeitsdauer ist vorbei.</li>
          }
          {fetchWrapper.customerPriceIncrease &&
            <li>Kunde hat seit Erstellung des Abrufs eine Preiserhöhung erhalten.</li>
          }
          {fetchWrapper.articleHasPriceRelevantChanges &&
            <li>Artikel wurde geändert.</li>
          }
        </ul>
      </div>

      <div className="modal-footer align-right">
        <EvButton variant="default"
                  type="button"
                  disabled={mutateFetchPriceConfirmIsPending}
                  onClick={() => mutateFetchPriceConfirm()}>
          Übernehmen
        </EvButton>
      </div>
    </EvReactModal>
  </>;
}
